export const ACCESS_DENIED_MESSAGE = 'The username or password you entered is incorrect. Please try again or reset your password. ';

export const isAuthError = (err) => {
    return err?.response?.status === 401;
}

export const isBlockedIpError = (err) => {
    if (err?.response?.status !== 403) return false;

    const message = (err?.response?.data?.message || '').toLowerCase();
    const blockedKeywords = ['ip address', 'access', 'denied', 'block'];

    return blockedKeywords.every((keyword) => message.includes(keyword));
}
